// src/components/CTAButton.jsx
import React from 'react';

const CTAButton = ({ text, onClick }) => {
    const redirectToWhatsapp = () => {
        const message = `Olá, gostaria de saber mais sobre as funcionalidades oferecidas!`;
        const whatsappUrl = `https://wa.me/5585982007804?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="w-full mt-10 text-center">
            <button
                className="bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-400 text-white py-3 px-6 sm:px-8 rounded-full shadow-lg transform transition-transform duration-300 hover:scale-105 w-full sm:w-auto"
                onClick={redirectToWhatsapp}
            >
                {text}
            </button>
        </div>
    );
};

export default CTAButton;
